import { APIEndpoints } from "../../constants";
import {
  APIPost,
  APIPostFormData,
  getAuthHeaders,
  getAuthFormDataHeaders,
  APIResponse,
} from "../api/common.service";
import {
  ArtworkSubmission,
  SubmitArtworkRequest,
  AssignmentCOQLResponseData,
  EditAssignmentRequest,
  EditAssignmentResponseData,
  AssignmentRecord,
} from "../../types";

export function SubmitArtwork(
  req: SubmitArtworkRequest,
): Promise<APIResponse<ArtworkSubmission>> {
  const formData = new FormData();
  formData.append("Name", req.assignment_name);
  if (req.teacher_id) {
    formData.append("Teacher", req.teacher_id);
  }

  req.files.forEach((file) => {
    formData.append("files", file, file.name);
  });

  return getAuthFormDataHeaders().then((headers) =>
    APIPostFormData<ArtworkSubmission>(
      APIEndpoints.SubmitArtwork,
      headers,
      formData,
    ),
  );
}

export function SearchTeacherAssignments(
  selectQuery: string,
): Promise<APIResponse<AssignmentCOQLResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<AssignmentCOQLResponseData>(
      APIEndpoints.GetTeacherSubmittedArtworks,
      headers,
      undefined,
      { selectQuery },
    ),
  );
}

export function EditAssignment(
  body: EditAssignmentRequest,
): Promise<APIResponse<EditAssignmentResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<EditAssignmentResponseData>(
      APIEndpoints.MarkArtwork,
      headers,
      undefined,
      body as unknown as Record<string, unknown>,
    )
  );
}

